import { Component } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SwUpdate } from '@angular/service-worker';
import { tap, take } from 'rxjs/operators';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  title = 'HealingOurVillage';
  constructor(private swUpdate: SwUpdate, private snack: MatSnackBar){}
  ngAfterContentInit(){
    this.swUpdate.available.subscribe(
      ()  => {
          this.snack.open("A new update is available!", 'update').onAction().pipe(
              tap(
                  () => {
                      this.swUpdate.activateUpdate().then( ( ) => window.location.reload())
                  }
              ), take(1)
          ).subscribe()
      }
    )
  }
}
